module.exports = __webpack_public_path__ + "files/e1c99641f4bd473bc8f977427143c128.png";